
export interface Avatar {
    initials: string,
    color: string
}

export function buildAvatar(
    userId: string,
    userName: string,
    questionId: string
): Avatar {
    const fieldToHash = userId || questionId;
    const hash = hashCode(fieldToHash);

    const color = COLORS[hash % COLORS.length];
    const initials = isAnonymous(userName)
        ? buildFakeInitials(hash)
        : parseInitials(userName);

    return {
        color,
        initials
    };
}

function isAnonymous(userName:string) {
    return !userName || userName.toLowerCase() === 'anonymous';
}

function hashCode(original: string): number {
    let sum = 0;

    for (let i = 0; i < (original || '').length; ++i) {
        sum += original.charCodeAt(i);
    }

    return sum;
}

function parseInitials(name: string): string {
    return (name || '')
        .trim()
        .replace(/[^\p{L}\s]/gu, '') // remove non-letter non-whitespace characters
        .split(/\s+/)
        .slice(0, 2)
        .map(i => i.charAt(0).toLocaleUpperCase())
        .join('');
}

function buildFakeInitials(hash: number) {
    const letter = GREEK_LETTERS[hash % GREEK_LETTERS.length];
    const digit = hash % 10;

    return letter + digit;
}



const COLORS = [
    '#6F1E00',
    '#705000',
    '#886F65',
    '#74564A',
    '#3B2823',
    '#B04021',
    '#CC3E20',
    '#80762C',
    '#457A3B',
    '#305C28',
    '#36685D',
    '#10828F',
    '#C4281B',
    '#C73461',
    '#B22F5B',
    '#7D1F4E',
    '#B52C61',
    '#9E50B6',
    '#8232A4',
    '#612794',
    '#431E87',
    '#9B2EF5',
    '#A60064',
    '#700041',
    '#775BBC',
    '#6041B1',
    '#7355F6',
    '#5823E1',
    '#5E6CBB',
    '#3466F6',
    '#2F65B9',
    '#1E499C',
    '#1A2679',
    '#001082',
    '#001082',
    '#00185A',
    '#DA1F77',
    '#965635',
    '#6162A9',
    '#7CA00D',
    '#529AA3',
    '#296FB4',
    '#264C41',
    '#596D79',
    '#495A63',
    '#757575',
    '#616161',
    '#212121',
    '#E46C51',
    '#D08015',
];

const GREEK_LETTERS = ['α', 'β', 'γ', 'δ', 'ε', 'ζ', 'η', 'θ', 'ι', 'κ', 'λ', 'μ', 'ν', 'ξ', 'ο', 'π', 'ρ', 'σ', 'τ', 'υ', 'φ', 'χ', 'ψ', 'ω'];
